import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Share = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="share icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 9C21.9853 9 24 6.98528 24 4.5C24 2.01472 21.9853 0 19.5 0C17.0147 0 15 2.01472 15 4.5C15 4.60672 15.0037 4.71257 15.011 4.81743L7.44867 8.59861C6.65894 7.913 5.62793 7.49802 4.5 7.49802C2.01472 7.49802 0 9.51274 0 11.998C0 14.4833 2.01472 16.498 4.5 16.498C5.62655 16.498 6.65642 16.084 7.44578 15.3999L15.011 19.1826C15.0037 19.2874 15 19.3933 15 19.5C15 21.9853 17.0147 24 19.5 24C21.9853 24 24 21.9853 24 19.5C24 17.0147 21.9853 15 19.5 15C18.2021 15 17.0325 15.5495 16.2112 16.4285L8.93082 12.7884C8.97628 12.5318 9 12.2677 9 11.998C9 11.7296 8.97651 11.4668 8.93147 11.2113L16.2112 7.57146C17.0325 8.4505 18.2021 9 19.5 9Z"
    />
  </svg>
)
